// extracted by mini-css-extract-plugin
export var sectionContainer = "Section-module--sectionContainer---Xp2D";